import { HttpInterceptorFn } from '@angular/common/http';
import { LocalStorageKeys } from '@shared-utils';
import { environment, PIMSEnvironment } from 'environments';

const environmentPIMS: PIMSEnvironment = environment as PIMSEnvironment;

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = window.localStorage.getItem(LocalStorageKeys.TOKEN) || '';
  let newReq = req;

  if (
    req.url.indexOf(environmentPIMS.constants.API_URL) >= 0 ||
    req.url.indexOf(environmentPIMS.constants.ADMIN_API_URL) >= 0 ||
    req.url.indexOf(environmentPIMS.constants.CMS_API_URL) >= 0 ||
    req.url.indexOf(environmentPIMS.constants.serverless_api_url) >= 0 ||
    req.url.indexOf(environmentPIMS.constants.serverless_tracking_api_url + 'tracking') >= 0
  ) {
    newReq = req.clone({
      headers: req.headers.set('Authorization', token).set('Accept', 'application/json'),
      ...(FEATURE_BODACDC_625 && ['POST', 'PUT', 'DELETE'].includes(newReq.method) ? { withCredentials: true } : {}),
    });
  }

  return next(newReq);
};
